/**
 * A PERSON'S NAME, in the script the interface reads (organiser, 15 Oct 2026 —
 * international competitions): in English, the name in Latin; in Ukrainian,
 * the name as written, with the patronymic.
 *
 * The Latin name is the server's (`latinName` on a profile and on a
 * participant's `historicalProfile`): typed on the profile, else the official
 * transliteration. Nothing is transliterated here.
 *
 * The language is kept here rather than read from i18next: this module is
 * imported by plain helpers (athleteLabel) that tests load without i18next.
 * `src/i18n.js` sets it on start-up and on every language change; the
 * components that show a name re-render on that change through their own
 * `useTranslation`.
 *
 * Imported by path, not through the `utils` barrel (see athleteLabel.js).
 */

let language = 'ua';

export const setNameLanguage = next => {
    language = next || 'ua';
};

/** Are names shown in Latin? */
export const namesInLatin = () => 'en' === language;

/**
 * «Прізвище Ім'я По батькові», or «Lastname Firstname» in Latin.
 * `latin` overrides the interface — a public screen of an international
 * competition always reads Latin.
 */
export const personName = (person, { middle = true, latin = namesInLatin() } = {}) => {
    if (!person) {
        return '';
    }

    const inLatin = latin && person.latinName && (person.latinName.lastName || person.latinName.firstName);
    const parts = inLatin
        ? [person.latinName.lastName, person.latinName.firstName]
        : [person.lastName, person.firstName, middle ? person.middleName : null];

    return parts.map(part => (part || '').trim()).filter(Boolean).join(' ');
};
